// extracted by mini-css-extract-plugin
module.exports = {"root":"errorMessage_root__pg_n4","errorMessage":"errorMessage_errorMessage__foFZM font-semibold leading-normal text-error text-sm"};